const accordion = () => {
  const accordions = document.querySelectorAll(".js-accordion-item");
  if (accordions.length == 0) {
    return;
  }
  const images = document.querySelectorAll(".js-accordion-image");
  const titles = document.querySelectorAll(".js-accordion-title");
  let baseTop = accordions[0].offsetTop;
  titles.forEach((title, index) => {
    title.addEventListener("click", () => {
      accordions[index].classList.toggle("active");
      images[index].classList.toggle("active");
    });
  });
  const resize = () => {
    baseTop = accordions[0].offsetTop;
    accordions.forEach((acc, index) => {
      let padding = parseInt(getComputedStyle(acc).paddingTop);
      let height = titles[index].getBoundingClientRect().height + padding;
      acc.style.maxHeight = height + "px";
    });
  };
  resize();
  window.addEventListener("resize", resize);
};

export default accordion;
